import React, { useMemo } from 'react'
import { useFormikContext } from 'formik'

import Card from '../../utils/Card'

const RequestFormValidationError = ({ name }) => {
  const requestForm = useFormikContext()

  const showError = useMemo(
    () => requestForm.getFieldMeta(name).touched && requestForm.getFieldMeta(name).error,
    [name, requestForm]
  )

  if (!showError) {
    return null
  }

  return (
    <Card color="lightOrange" small className="inline-block mt-1">
      <span className="text-lg font-bold">{requestForm.getFieldMeta(name).error}</span>
    </Card>
  )
}

export default RequestFormValidationError
